module.exports = __webpack_public_path__ + "static/media/sicpa.6fd02148.png";